goog.provide('el8.util.validate');

goog.require('el8.service.tz');
goog.require('el8.util.consts');
goog.require('el8.util.datecompare');


el8.util.validate = (function() {
    var that = {
        standardOpts: {
            highlight: function(element) {
                // TODO Should NOT rely on existence of camelCase CSS classes for DOM traversal
                $(element).closest('.field-wrapper').find('.validate-section').show();
                $(element).closest('.el8TextareaWrap, .el8Wrap, .el8NoPaddingWrap, .el8EditorTextareaWrap').addClass('el8WrapAlert');
            },
            unhighlight: function(element) {
                // TODO Should NOT rely on existence of camelCase CSS classes for DOM traversal
                $(element).closest('.field-wrapper').find('.validate-section').hide();
                $(element).closest('.el8TextareaWrap, .el8Wrap, .el8NoPaddingWrap, .el8EditorTextareaWrap').removeClass('el8WrapAlert');
            },
            errorPlacement: function(error, element) {} // keep hidden
        },

        standardOptsWithCallback: function(callbackFn) {
            return {
                highlight: function(element) {
                    that.standardOpts.highlight(element);
                    callbackFn();
                },
                unhighlight: function(element) {
                    that.standardOpts.unhighlight(element);
                    callbackFn();
                },
                errorPlacement: function(error, element) {} // keep hidden
            };
        },

        highlightInputOpts: {
            highlight: function(element, errorClass) {
                $(element).addClass('hasError');
                $(element).closest('.el8Wrap, .el8TextareaWrap, .fieldContainerNoBorder').addClass('hasErrorIcon');
            },
            unhighlight: function(element, errorClass) {
                $(element).removeClass('hasError');
                $(element).closest('.el8Wrap, .el8TextareaWrap, .fieldContainerNoBorder').removeClass('hasErrorIcon');
            },
            errorPlacement: function(error, element) {} // keep hidden
        }
    };
    return that;
})();

$.validator.addMethod('exactlength', function(value, element, param) {
    return (this.optional(element) || this.getLength($.trim(value), element) === param);
}, $.validator.format('Please enter exactly {0} characters'));

$.validator.addMethod('ssn', function(value, element) {
    return (this.optional(element) || (value.replace(/[^0-9]/g,'').length === 9 && /^[0-9\-]+$/.test(value)));
}, 'Valid SSN requires 9 digits');

$.validator.addMethod('tin', function(value, element) {
    return (this.optional(element) || (value.length === 9 && /^\d+$/.test(value)));
}, 'Please enter a valid 9-digit TIN');

$.validator.addMethod( 'todayOrBefore', function(value, element) {
    var _date = el8.service.tz.newTzDateTime(value);
    return (this.optional(element) || (_date<el8.service.tz.now() || el8.util.datecompare.isToday(_date)));
}, 'Date must be today or before');

$.validator.addMethod('todayOrAfter', function(value, element) {
    var _date = el8.service.tz.newTzDateTime(value);
    return (this.optional(element) || el8.util.datecompare.isTodayOrAfter(_date));
}, 'Date must be today or before');

$.validator.addMethod('afterYear1900', function(value, element) {
    return (this.optional(element) || (el8.service.tz.newTzDate(value) >= el8.service.tz.newTzDate('1/1/1900')));
}, 'Date must be after the year 1900.');

$.validator.addMethod( 'validDate', function(value, element) {
    return (this.optional(element) || el8.util.datecompare.dateFromStr(value));
}, 'Please enter date in correct format: '+Date.format.toUpperCase()+'.');

$.validator.addMethod( 'validTime', function(value, element) {
    return (this.optional(element) || value.match(/\d{1,2}:(\d\d) ?[ap]m/i));
}, 'Please enter time in correct format: '+Date.timeOnlyFormat.toUpperCase()+'.');

$.validator.addMethod("phone", function(phone_number, element) {
    phone_number = phone_number.replace(/\s+/g, "");
    return this.optional(element) || phone_number.length > 9 &&
        phone_number.match(/^(1-?)?(\([1-9]\d{2}\)|[1-9]\d{2})-?[1-9]\d{2}-?\d{4}$/);
}, "Please specify a valid phone number");

$.validator.addMethod("unitsInUCUM", function(value, element) {
    return this.optional(element) || el8.util.consts.IMMUNIZATION_REGISTRY_QUANTITY_UNITS.indexOf(value) > -1;
}, "Please specify a valid UCUM unit");

$.validator.addMethod("state", function(value, element) {
    return this.optional(element) || (value.length === 2 &&
        /^AL$|^AK$|^AS$|^AZ$|^AR$|^CA$|^CO$|^CT$|^DE$|^DC$|^FM$|^FL$|^GA$|^GU$|^HI$|^ID$|^IL$|^IN$|^IA$|^KS$|^KY$|^LA$|^ME$|^MH$|^MD$|^MA$|^MI$|^MN$|^MS$|^MO$|^MT$|^NE$|^NV$|^NH$|^NJ$|^NM$|^NY$|^NC$|^ND$|^MP$|^OH$|^OK$|^OR$|^PW$|^PA$|^PR$|^RI$|^SC$|^SD$|^TN$|^TX$|^UT$|^VT$|^VI$|^VA$|^WA$|^WV$|^WI$|^WY$/.test(value.toUpperCase()));
}, "Please specify a valid US state");

$.validator.addMethod("zip", function(value, element) {
    return this.optional(element) ||
        (value.length === 5 && /^\d{5}$/.test(value)) ||
        (value.length === 9 && /^\d{9}$/.test(value)) ||
        (value.length === 10 && /^\d{5}\-\d{4}$/.test(value));
}, "Zip has to be either 5 digits, or 5+4 digits");

$.validator.addMethod("documentTags", function(value, element) {
    var tags = value.split(',');
    return this.optional(element) || (function() {
        for (var i=0; i<tags.length; i++) {
            if (tags[i].trim().length > 100) { return false; }
        }
        return true;
    })();
}, "Each tag can be at most 100 characters long");

$.validator.addMethod("icd9", function(value, element) {
    return this.optional(element) || el8.util.smart.validateIcd9Code(value);
}, "Please enter a valid ICD-9 code");
